import Heading1 from "./Heading1";
import Heading2 from "./Heading2";
import Span from "./Span";
import Paragraph from "./Paragraph";
import SmallText from "./SmallText";
import Label from "./Label";

export { Heading1, Heading2, Span, Paragraph, SmallText, Label };
